import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "u-flex-start-end u-flex-vertical __group" }
const _hoisted_2 = { class: "__code" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "__info" }, "HEX code copy!!", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", {
    class: "__rectangle u-italic u-flex-end-start",
    style: _normalizeStyle({background: _ctx.propsCode, color: _ctx.codeTextColor(_ctx.propsCode)}),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyCode(_ctx.propsCode)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.propsCode), 1 /* TEXT */),
      _hoisted_3
    ])
  ], 4 /* STYLE */))
}